import { makeStyles } from '@mui/styles';

export const useItemDetailsSubstituteStyle = makeStyles(() => ({
  hidden: {
    display: 'none',
  },
}));
